import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../common/Breadcrumbs';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';

/**
 * Page header component with optional breadcrumbs and action buttons
 * Uses semantic color classes from shared configuration
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {Array} [props.breadcrumbs] - Optional array of breadcrumb items with label and path
 * @param {React.ReactNode} [props.buttons] - Optional action buttons
 * @param {boolean} [props.showTitle=true] - Whether to display the title
 */
const PageHeader = ({ title, breadcrumbs, buttons, showTitle = true, className = '' }) => {
  const colors = useColors();
  const semantic = colors.semantic;
  const { replace } = useTextReplacement();

  return (
    <div className={`mt-0 mb-6 ${className || ''}`}>
      {/* Title row */}
      {showTitle && title && (
        <div className="mb-2">
          <h1 className={`text-center text-2xl md:text-3xl font-bold ${semantic.contentCardHeading}`}>
            {replace(title)}
          </h1>
        </div>
      )}
      
      {/* Breadcrumbs and buttons row */}
      <div className="flex items-center justify-between flex-wrap gap-4">
        {breadcrumbs && (
          <div className="flex-1 min-w-0">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}
        {buttons && (
          <div className="flex gap-2 flex-shrink-0">
            {buttons}
          </div>
        )}
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  ),
  buttons: PropTypes.node,
  showTitle: PropTypes.bool,
};

export default PageHeader;

